import { tokenAtom, urlLogoutAtom } from 'atoms';
import { useNavigate } from 'react-router-dom';
import { useRecoilCallback, useRecoilValue } from 'recoil';

function useLogout() {
  const urlLogout = useRecoilValue(urlLogoutAtom);
  const navigate = useNavigate();

  const handleLogout = useRecoilCallback(
    ({ reset }) =>
      () => {
        if (urlLogout) {
          navigate('/redirecting');
          window.location.href = urlLogout;
        }
        reset(tokenAtom);
      },
    [urlLogout],
  );

  return { handleLogout };
}

export default useLogout;
